module.exports = __webpack_public_path__ + "static/media/mw.baf490bf.svg";